import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { statusBar } from '../hooks/useCapacitorPlugins.js';

const THEMES = ['midnight', 'arena', 'zen'];
const STORAGE_KEY = 'gameday-theme';

const ThemeContext = createContext({ theme: 'arena', setTheme: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return THEMES.includes(saved) ? saved : 'arena';
    } catch { return 'arena'; }
  });

  const setTheme = useCallback((t) => {
    if (!THEMES.includes(t)) return;
    setThemeState(t);
    try { localStorage.setItem(STORAGE_KEY, t); } catch {}
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    // Update theme-color meta tag for mobile browser chrome
    const meta = document.querySelector('meta[name="theme-color"]:not([media])');
    const metaVal = getComputedStyle(document.documentElement).getPropertyValue('--theme-meta').trim();
    if (meta && metaVal) meta.setAttribute('content', metaVal);
    // Native apps: status bar text dark on the light themes, light on Midnight.
    statusBar.syncToTheme();
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, themes: THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
